import './EquipmentHistory.scss';
import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { Loading, Error } from '../../_common';
import { useParams } from 'react-router-dom';
import { GET_EQUIPMENT_LOGGERS } from '../../../graphql/client/queries';
import EquipmentHistoryList from './EquipmentHistoryList';
import { GetEquipmentLoggers, GetEquipmentLoggers_getEquipmentLoggers as LoadLogger } from '../../../types/schemaTypes';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';

const EquipmentHistory = ({ match }: any): React.ReactElement => {
    const [tabTitle, setTabTitle] = useState(document.title);
    const { loadId } = useParams()
    const loadIdParam: any = loadId;
    const [searchPhrase, setSearchPhrase] = useState('');
    const authContext = useAuthContext();
    const canViewHistory = authContext.userHasPermission(PermissionEnum.ViewAssetLoadHistory);

    const variables = {
        input: {
            loadId: +loadIdParam,
            search: ''
        }
    };

    const { error, data, loading } = useQuery<GetEquipmentLoggers>(GET_EQUIPMENT_LOGGERS, {
        variables: variables,
        fetchPolicy: 'network-only',
        pollInterval: 60000,
        skip: !canViewHistory,
    });

    const goBackToLoadProfile = (): void => {
        window.history.back();
    };

    const onSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const searchValue = event.target.value;
        setSearchPhrase(searchValue);
    };

    useEffect(() => {
        document.title = 'AssetLoad :' + loadIdParam;
        setTabTitle(document.title);
    }, [loadIdParam, searchPhrase]);

    let loadLoggers: LoadLogger[] = [];
    if (data?.getEquipmentLoggers) {
        loadLoggers = data.getEquipmentLoggers.filter((l): l is LoadLogger => l != null);
    }

    if (!canViewHistory) {
        return (
            <div className="NoResult-Container Inventory-Unauth-Container">
                <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
            </div>
        )
    }

    if (loading) {
        <div className="EquipmentProfile-Loading">
            <Loading />
        </div>
    }

    if (
        CombinedGraphQLErrors.is(error) &&
        error.errors[0]?.extensions?.response &&
        error.errors[0].extensions.response['body']?.Message?.includes('deleted')
    ) {
        return (
            <div className="EquipmentHistory-Container">
                <div className="EquipmentHistory-Header">
                    <div className="EquipmentHistory-SearchBarContainer">
                        <i className="material-icons EquipmentHistory-SearchBarIcon">search</i>
                        <input
                            id="textSearch"
                            type="text"
                            placeholder="Search"
                            className="EquipmentHistory-SearchBarInput"
                            onChange={onSearch}
                        />
                    </div>
                    <div className="EquipmentHistory-HeaderTitle">
                        {`Load #:`}
                        <span className="EquipmentHistory-LoadNumber">{loadIdParam}</span>
                    </div>
                    <div className="EquipmentHistory-ToggleButtonsContainer">
                        <div className="EquipmentHistory-LeftToggleButton" onClick={goBackToLoadProfile}>
                            <p className="EquipmentHistory-ButtonText">Load Details</p>
                        </div>
                        <div className="EquipmentHistory-RightToggleButton LoadHistory-ActiveButton">
                            <p className="EquipmentHistory-ButtonText">Load History</p>
                        </div>
                    </div>
                </div>

                <div className="NoResult-Container EquipmentHistory-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Load Deleted</div>
                    <div className="NoResult-Second-Title-Secondary">This load is already deleted!</div>
                </div>
            </div>
        )
    }

    if (error) {
        return <Error error={error} />;
    }

    return (
        <div className="EquipmentHistory-Container">
            <div className="EquipmentHistory-Header">
                <div className="EquipmentHistory-SearchBarContainer">
                    <i className="material-icons EquipmentHistory-SearchBarIcon">search</i>
                    <input
                        id="textSearch"
                        type="text"
                        placeholder="Search"
                        className="EquipmentHistory-SearchBarInput"
                        onChange={onSearch}
                    />
                </div>
                <div className="EquipmentHistory-HeaderTitle">
                    {`Load #:`}
                    <span className="EquipmentHistory-LoadNumber">{loadIdParam}</span>
                </div>
                <div className="EquipmentHistory-ToggleButtonsContainer">
                    <div className="EquipmentHistory-LeftToggleButton" onClick={goBackToLoadProfile}>
                        <p className="EquipmentHistory-ButtonText">Load Details</p>
                    </div>
                    <div className="EquipmentHistory-RightToggleButton LoadHistory-ActiveButton">
                        <p className="EquipmentHistory-ButtonText">Load History</p>
                    </div>
                </div>
            </div>
            <EquipmentHistoryList loadLoggers={loadLoggers} searchPhrase={searchPhrase} />
        </div>
    );
};
export default EquipmentHistory;

